import type { ApiGroupMember } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type GroupMembersCreatedEvent = AvvirEvent<typeof GROUP_MEMBERS_CREATED, ApiGroupMember[]>

const groupMembersCreated = (groupMembers: ApiGroupMember[]): GroupMembersCreatedEvent => ({
  type: GROUP_MEMBERS_CREATED,
  payload: groupMembers
});

export const GROUP_MEMBERS_CREATED = "group_members_created";

export default groupMembersCreated;
